import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from './utils/enhancedAuthTokenHttp';

interface GetDashboardResponse {
  portfolioByBorrowerType: {
    borrower_type: string;
    count: number;
  }[];
  portfolioByBorrowerStatus: {
    borrower_status: string;
    count: number;
  }[];
  portfolioByPropertyType: {
    property_type: string;
    min: number;
    max: number;
  }[];
}

const notImplemented = true;
const getDashboard = async (): Promise<GetDashboardResponse> => {
  if (isMockServices() || notImplemented)
    return await mock(_mockData, { delay: 500 });

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GetDashboardResponse>('/dashboard', {
    method: 'GET',
  });
  if (response.data) return response.data;
  throw new Error('Failed to fetch loans');
};

export default getDashboard;

const _mockData: GetDashboardResponse = {
  portfolioByBorrowerStatus: [
    { borrower_status: 'Inquiry', count: 20 },
    { borrower_status: 'Application', count: 15 },
    { borrower_status: 'Loan', count: 45 },
    { borrower_status: 'Others', count: 20 },
  ],
  portfolioByBorrowerType: [
    { borrower_type: 'W2 Borrowers', count: 50 },
    { borrower_type: 'Self Employed', count: 30 },
    { borrower_type: `Retirees`, count: 20 },
  ],
  portfolioByPropertyType: [
    { property_type: 'Single Family', min: 5, max: 15 },
    { property_type: 'Town Home', min: 6, max: 16 },
    { property_type: 'Condo', min: 4, max: 17 },
    { property_type: 'Multi Family', min: 3, max: 16 },
  ],
};
